export const siteConfig = {
  name: '洞洞杂货铺漫画',
  shortName: '洞洞杂货铺',
  slogan: '读懂每一个空缺，也读懂光照进来的地方',
  description:
    '洞洞杂货铺漫画是什么？这里是关于《洞洞杂货铺》漫画世界观、故事背景与“洞洞”含义的完整科普站，帮你快速看懂这部独特漫画的设定逻辑。',
  email: 'hello@dongdong-zahuopu.example',
  keywords:
    '洞洞杂货铺漫画,洞洞杂货铺漫画是什么,洞洞杂货铺设定,洞洞杂货铺世界观,洞洞杂货铺故事背景,洞洞杂货铺洞洞含义',
};

export const navLinks = [
  { label: '首页', path: '/' },
  { label: '设定与世界观', path: '/lore' },
  { label: '常见问题', path: '/faq' },
  { label: '关于本站', path: '/about' },
];